import React, { useEffect, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';

import DeveloperPage from '../../styles/templates/DeveloperPage';
import { DevPortalTestingAccount } from '../../interfaces/user';
import { getTestingAccount } from '../../services/DevPortalService';
import { emptyDevPortalTestingAccount } from '../../constants/devPortalTestingAccount';
import TestingAccountDetails from '../../components/TestAccountDetails/TestAccountDetails';
import Paper from '../../styles/templates/Paper';
import PageHeader from '../../styles/templates/PageHeader';

type PropsType = {
  path?: string;
  default?: boolean;
};

const ProjectsPage: React.FC<PropsType> = () => {
  const [user, setUser] = useState<DevPortalTestingAccount>(emptyDevPortalTestingAccount);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    const getTesting = async () => {
      try {
        const res = await getTestingAccount();
        if (res.parsedBody && res.parsedBody.length > 0) {
          setUser(res.parsedBody[0]);
        }
      } catch (e) {
        // TODO Add error handling
      }
    };

    getTesting();
  }, []);

  const onCopy = () => setSnackbarOpen(true);

  const handleClose = (_?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  return (
    <>
      <DeveloperPage>
        <PageHeader
          title="Test Account"
          subtitle="View log in details for your Developer Test Account"
        />

        <Paper>
          <Typography variant="subtitle1">Developer Test Account View</Typography>

          <TestingAccountDetails user={user} onCopy={onCopy} />
        </Paper>
      </DeveloperPage>

      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Copied to Clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProjectsPage;
